var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRanking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.667 9.333c-.734 0-1.334.6-1.334 1.334v4H5.78V9.333H2.667z",
    stroke: "#403D5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.107 6.667c-.734 0-1.334.6-1.334 1.333v6.667h4.447V8c0-.733-.593-1.333-1.333-1.333h-1.78zM10.22 11.333v3.334h4.447v-2c0-.734-.6-1.334-1.334-1.334H10.22z",
    stroke: "#403D5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7 2.087c.047.1.173.193.28.206l.64.107c.407.067.507.367.213.653l-.5.5a.426.426 0 00-.106.36l.14.614c.113.486-.147.673-.574.42l-.6-.354a.412.412 0 00-.393 0l-.6.354c-.427.253-.687.066-.573-.42l.14-.614a.42.42 0 00-.107-.36l-.493-.493c-.294-.293-.2-.587.213-.653l.64-.107a.444.444 0 00.28-.207l.353-.706c.194-.387.5-.387.694-.007l.353.707z",
    stroke: "#A0A3BD"
  }))));
}

export default SvgRanking;